//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: String,
    type: String,
    showMoreInfo: Boolean,
    selloutEnums: Object
  },
  methods: {
    onClick: function onClick() {
      this.$emit('buttonClick');
    }
  }
};